import React from 'react';

function Header() {
    return(
        <h1 className='title has-text-centered'>A Simple To Do App</h1>
    )
}

export default Header